import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filterButton"]

  connect() {
    this.currentFilter = "all"
    this._boundDestroy = this.destroyDatatable.bind(this)
    this.initializeDatatable()
    document.addEventListener("turbo:before-cache", this._boundDestroy)
  }

  disconnect() {
    this.destroyDatatable()
    document.removeEventListener("turbo:before-cache", this._boundDestroy)
  }

  filter(event) {
    event.preventDefault()
    this.currentFilter = event.currentTarget.dataset.filterValue

    this.filterButtonTargets.forEach(btn => {
      btn.classList.toggle("kpi-filter-btn--active", btn.dataset.filterValue === this.currentFilter)
    })

    this.dataTable.draw()
  }

  // private

  initializeDatatable() {
    const table = $(this.element.querySelector(".datatables-kpi"))

    if ($.fn.DataTable.isDataTable(table)) {
      table.DataTable().destroy()
    }

    this._searchFilter = (_settings, _data, _dataIndex) => {
      if (_settings.nTable !== table[0]) return true
      if (this.currentFilter === "all") return true

      const row = _settings.aoData[_dataIndex].nTr
      return row && row.dataset.status === this.currentFilter
    }
    $.fn.dataTable.ext.search.push(this._searchFilter)

    this.dataTable = table.DataTable({
      autoWidth: false,
      order: [[2, "desc"]],
      columnDefs: [{ targets: "_all", orderSequence: ["desc", "asc"] }],
      dom: '<"row"<"col-md-6"l><"col-md-6"f>>rt<"row"<"col-md-12"p>>',
      displayLength: 25,
      lengthMenu: [10, 25, 50, 100],
      responsive: false,
      ...window.datatablesDefaults
    })
  }

  destroyDatatable() {
    const table = $(this.element.querySelector(".datatables-kpi"))
    if ($.fn.DataTable.isDataTable(table)) {
      const idx = $.fn.dataTable.ext.search.indexOf(this._searchFilter)
      if (idx !== -1) $.fn.dataTable.ext.search.splice(idx, 1)
      table.DataTable().destroy()
    }
  }
}
